/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SubmitAutomationForFlowRequest} from '@cash-web/protos/squareup/cash/investautomator/api/flows/submitAutomationForFlow.pb'
import {SubmitAutomationForFlowResponse} from '@cash-web/protos/squareup/cash/investautomator/api/flows/submitAutomationForFlow.pb'


export const submitAutomationForFlow = (request:SubmitAutomationForFlowRequest, options?: CashRequestOptions) => post<SubmitAutomationForFlowRequest, SubmitAutomationForFlowResponse>("/2.0/cash/submit-automation-for-flow", request, {...options, rejectOnError: true })